/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { DiscoveryApi } from '@backstage/core-plugin-api';

export type CreateTicketRequest = {
  summary: string;
  description: string;
  project: string;
  issueType: IssueType;
  priority: TicketPriority;
  requestingTeam?: string; // Required for PRE Tickets
};

export type CreateTicketResponse = {
  ticketId: string;
  ticketKey: string;
  ticketLink: string;
};

export type AddCommentRequest = {
  comment: string;
  ticketId: string;
};

export type AddCommentResponse = {
  commentLink: string;
};

export enum IssueType {
  Bug = 'Bug',
  Task = 'Task',
  Story = 'Story',
  Epic = 'Epic',
}

export enum TicketPriority {
  P1 = '1',
  P2 = '2',
  P3 = '3',
  P4 = '4',
}

export interface JiraApptioApi {
  createTicket(request: CreateTicketRequest): Promise<CreateTicketResponse>;
  addComment(request: AddCommentRequest): Promise<AddCommentResponse>;
}

export type ClientApiConfig = {
  discovery: DiscoveryApi;
};
